import React from 'react'

import { PriorityType } from '../../types/shared'

export function useForceUpdate() {
  const [forceUpdateKey, increment] = React.useState(0)
  const forceUpdate = React.useCallback((priority: PriorityType = 'low') => {
    const incrementFn = () => {
      increment((prev) => prev + 1)
    }
    if (priority === 'low') {
      React.startTransition(incrementFn)
    } else if (priority === 'high') {
      incrementFn()
    }
  }, [])

  const forceUpdateLowPriority = React.useCallback(() => {
    forceUpdate('low')
  }, [forceUpdate])

  return { forceUpdate, forceUpdateLowPriority, forceUpdateKey }
}
